import { PhonePipe } from '../shared/phone/phone.pipe';

/**
 * turns formated phone number into plane digits.
 * @param {string} number
 * @return {string}
 */
export function undoPhoneFormat (number: string): string {
  if (!number) {
    return number;
  }
  let tempNumber = '';

  for (let i = 0; i < number.length; ++i) {
    const char = number.charAt(i);
    if (!isNaN(parseInt(char, null))) {
      tempNumber += char;
    }
  }
  return tempNumber;
}

/**
 * this function is used to format phone number input fields on a form as it is being entered.
 * @param {string} number
 * @return {any}
 */
export function formatPhoneString(number: string): any {
  if (!number) {
    return number;
  }

  const unformatedNumber = undoPhoneFormat(number);
  switch (unformatedNumber.length) {
    case 0:
      return `(`;
    case 1:
    case 2:
      return `(${unformatedNumber}`;
    case 3:
      return `(${unformatedNumber})`;
    case 4:
    case 5:
      return `(${unformatedNumber.substr(0, 3)}) ${unformatedNumber.substr(3)}`;
    case 6:
      return `(${unformatedNumber.substr(0, 3)}) ${unformatedNumber.substr(3)}-`;
    case 7:
    case 8:
    case 9:
      return `(${unformatedNumber.substr(0, 3)}) ${unformatedNumber.substr(3, 3)}-${unformatedNumber.substr(6)}`;
    case 10:
      return new PhonePipe().transform(unformatedNumber);
    case 11:
      if (unformatedNumber.substr(0, 1) === '1') {
        return new PhonePipe().transform(unformatedNumber);
      }
      return unformatedNumber;
    default:
      return unformatedNumber;
  }
}
